<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <OliveOilsForm @submit-requested="submitRequested"></OliveOilsForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import OliveOilsForm from './OliveOilsForm.vue'

  export default {
  components: { OliveOilsForm },
  methods: {
    ...mapActions('oliveOils', ['postOliveOil']),
    submitRequested (input) {
      this.postOliveOil(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 